const coverMap = {
  noah_ark: "/covers/noah_ark_cover.png",
  david_goliath: "/covers/david_goliath_cover.png",
  moses: "/covers/moses_cover.png",
  color_by_number: "/covers/color_by_number_cover.png",
  jesus_feeds_5000: "/covers/jesus_feeds_5000_cover.png",
  adam_eve: "/covers/adam_eve_cover.png"
};

const getCoverImage = (packId) => {
  return coverMap[packId] || "/covers/bible_heroes_main.png";
};

export default getCoverImage;
